import { RECEIVE_ACCOUNT_DATA } from "./actions";

import type { Action } from "./store";

export const accountId = (state: string = "", action: Action): string => {
  if (action.type === RECEIVE_ACCOUNT_DATA) {
    return action.payload.id || state;
  }
  return state;
};
